import {
  ContentPageSortField,
  ContentSortOrder,
} from '@xing-com/crate-common-graphql-types';

export const getSortOrder = (
  sortField: ContentPageSortField
): ContentSortOrder => {
  const isSortOrderAscending = sortField === ContentPageSortField.Title;

  return isSortOrderAscending ? ContentSortOrder.Asc : ContentSortOrder.Desc;
};
